module.exports = __webpack_public_path__ + "img/ghponeh.13dfe942.png";